import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getCurrentAdminUser } from '../services/authService';

function Header() {
    const [adminUser, setAdminUser] = useState(null);
    const location = useLocation();

    useEffect(() => {
        const user = getCurrentAdminUser();
        setAdminUser(user);
    }, []);

    const getHeaderContent = () => {
        const path = location.pathname;
        
        switch (path) {
            case '/admin/dashboard':
                return {
                    title: 'Dashboard',
                    description: 'Manage all platform data here'
                };
            case '/admin/customers':
                return {
                    title: 'Customers Management',
                    description: 'Manage users , their bundles and activity'
                };
           
            default:
                return {
                    title: 'Dashboard',
                    description: 'Manage all platform data here'
                };
        }
    };

    const headerContent = getHeaderContent();

    return (
        <>
        
<div className="header">
  <div className="header-left">
    <h3>{headerContent.title}</h3>
    <h4>{headerContent.description}</h4>
  </div>
  <div className="header-right">
  
    <div className="admin-login">
      
      <div className="admin-info">
        <h3>{adminUser?.name || adminUser?.email || 'Admin User'}</h3>
        <h4>{adminUser?.role || 'Admin'}</h4>
      </div>
    </div>
  </div>
</div>

        </>
    );
}

export default Header;
